import { useState } from "react";
import Cookies from "js-cookie";
import Container from "react-bootstrap/Container";
import { Link } from "react-router-dom";

import "./PolicyModal.css";

export default function PolicyModal(props) {
  const [isCookieSet, setCookie] = useState(Cookies.get("cookieConsent"));

  const hidePolicyModal = () => {
    document.getElementById("policy-modal-container").style.display = "none";
  };

  const handleAcceptCookies = () => {
    Cookies.set("cookieConsent", true);
    setCookie(true);
    hidePolicyModal();
    console.log("Aware about cookies: " + isCookieSet);
  };

  return (
    <div className="policy-container">
      <Container id="policy-modal-container">
        <p style={{ color: props.textColor }}>
          Utilizamos cookies para melhorar sua experiência em nosso site. Ao
          continuar navegando, você concorda com nossa{" "}
          <Link
            style={{ color: props.titleColor }}
            to="/privacidade/"
            className="modal-link"
          >
            Política de Privacidade e de Cookies.
          </Link>
        </p>
        <button
          onClick={handleAcceptCookies}
          style={{ color: props.white, backgroundColor: props.btnColor }}
          className="modal-btn"
        >
          OK
        </button>
      </Container>
    </div>
  );
}
